var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('TopNav',{scopedSlots:_vm._u([{key:"menu",fn:function(){return _vm._l((_vm.primaryNav),function(navLink){return _c('TopNavButton',{key:navLink.name,attrs:{"link":navLink}})})},proxy:true},{key:"actions",fn:function(){return [_c('TopNavSave'),[_c('TopNavUndoRedo')]]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }